/**
 * Return true if the input is a pure object not a date, array or function
 */
function isPureObject(input) {
  return (
    null !== input &&
    typeof input === 'object' &&
    Object.getPrototypeOf(input).isPrototypeOf(Object)
  );
}

/**
 * Remove trailing white spaces from strings and return the new values object
 */
export function trimStrings(values) {
  const trimmedValues = Object.keys(values).reduce((acc, key) => {
    if (Array.isArray(values[key])) {
      // Trim strings in array
      acc[key] = values[key].map(item => {
        if (Array.isArray(item)) {
          return trimStrings(item);
        }
        if (typeof item === 'string') {
          return item.trim();
        }
        if (typeof item === 'object' && isPureObject(item)) {
          // Trim strings in nested objects inside the array
          return trimStrings(item);
        }
        return item;
      });
    } else if (typeof values[key] === 'string') {
      // Trim strings
      acc[key] = values[key].trim();
    } else if (typeof values[key] === 'object' && isPureObject(values[key])) {
      // Trim all strings in the object if the object is nested
      acc[key] = trimStrings(values[key]);
    } else {
      acc[key] = values[key];
    }
    return acc;
  }, {});
  return trimmedValues;
}
